var _style, _path, _polygon, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMvLogoMin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 69.5 60",
    style: {
      enableBackground: "new 0 0 69.5 60"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#0677FF;}\r\n\t.st1{clip-path:url(#SVGID_00000049183557449827018220000017669421170868913559_);}\r\n\t.st2{fill:url(#SVGID_00000114038877385562324780000012527810642761366936_);}\r\n\t.st3{fill:url(#SVGID_00000024702891502262985990000015551703803310539172_);}\r\n\t.st4{fill:url(#SVGID_00000183934752684654342010000002376543246650830728_);}\r\n")), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M68.6,44.4l-9.7-23.2l-5.3,2.3l9.6,23.2c0.6,1.3,0.6,2.8,0,4.2s-1.6,2.4-2.9,2.9c-2.8,1.2-5.9-0.2-7.1-2.9 l-9.7-23.2l0,0l-0.2-0.4c-1.5-3.5-4.8-5.7-8.6-5.7l0,0c-3.8,0-7.1,2.2-8.6,5.7L26,27.5l0,0l-9.7,23.2c-1.2,2.8-4.3,4.1-7.1,2.9 C7.9,53,6.8,52,6.3,50.7s-0.5-2.8,0-4.2L16,23.4l-5.4-2.3L0.9,44.3c-1.2,2.8-1.2,5.8,0,8.6s3.3,5,6.1,6.1c1.4,0.6,2.9,0.9,4.3,0.9 c4.4,0,8.6-2.6,10.4-6.9l7.4-17.7l0,0l2.5-5.9c0.8-1.9,2.6-2.1,3.1-2.1s2.3,0.2,3.2,2.1l2.5,5.9l0,0L47.8,53 c1.8,4.3,6,6.9,10.4,6.9c1.4,0,2.9-0.3,4.3-0.9c2.8-1.2,4.9-3.3,6.1-6.1C69.8,50.2,69.8,47.1,68.6,44.4L68.6,44.4L68.6,44.4z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "34.7,51.9 19.4,15.2 6.8,45.4 1.4,43.2 19.4,0 34.7,36.7 50.1,0 68.1,43.2 62.7,45.4 50.1,15.2  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M68.6,44.4l-9.7-23.2l-5.3,2.3l9.6,23.2c0.6,1.3,0.6,2.8,0,4.2s-1.6,2.4-2.9,2.9 c-2.8,1.2-5.9-0.2-7.1-2.9l-9.9-23.6c-1.5-3.5-4.8-5.7-8.6-5.7l0,0c-3.8,0-7.1,2.2-8.6,5.7L26,27.5l-9.7,23.2 c-1.2,2.8-4.3,4.1-7.1,2.9C7.9,53,6.8,52,6.3,50.7s-0.5-2.8,0-4.2L16,23.4l-5.4-2.3L0.9,44.4c-1.2,2.8-1.2,5.8,0,8.6 s3.3,5,6.1,6.1c1.4,0.6,2.9,0.9,4.3,0.9c4.4,0,8.6-2.6,10.4-6.9l7.4-17.7l0,0l2.5-5.9c0.8-1.9,2.6-2.1,3.1-2.1s2.3,0.2,3.2,2.1 l2.5,5.9l0,0l7.4,17.7c1.8,4.3,6,6.9,10.4,6.9c1.4,0,2.9-0.3,4.3-0.9c2.8-1.2,4.9-3.3,6.1-6.1C69.7,50.2,69.7,47.1,68.6,44.4 L68.6,44.4L68.6,44.4z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000109028083896196563500000005576636845677160585_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SVGID_00000109028083896196563500000005576636845677160585_)"
    }
  }, /*#__PURE__*/React.createElement("radialGradient", {
    id: "SVGID_00000054237183282034395780000004842451432429899164_",
    cx: 117.116,
    cy: -52.4233,
    r: 84.81,
    gradientTransform: "matrix(0.87 0 0 -0.87 -67.7222 -21.4574)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    style: {
      stopColor: "#DD45C7"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    style: {
      stopColor: "#D447C9",
      stopOpacity: 0.98
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    style: {
      stopColor: "#BC4CCF",
      stopOpacity: 0.92
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    style: {
      stopColor: "#9455D9",
      stopOpacity: 0.83
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    style: {
      stopColor: "#5E62E7",
      stopOpacity: 0.71
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    style: {
      stopColor: "#1972F9",
      stopOpacity: 0.55
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#0677FF",
      stopOpacity: 0.5
    }
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "url(#SVGID_00000054237183282034395780000004842451432429899164_)"
    },
    cx: 34.4,
    cy: 24.4,
    r: 74
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000004504346287636402360000009471206339492873398_",
    gradientUnits: "userSpaceOnUse",
    x1: 241.6278,
    y1: 316.6848,
    x2: 236.0478,
    y2: 343.7148,
    gradientTransform: "matrix(0.9201 0.4166 0.3886 -0.9986 -285.9757 266.7901)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0677FF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#0677FF"
    }
  })), /*#__PURE__*/React.createElement("rect", {
    x: 53.5,
    y: 21.1,
    style: {
      fill: "url(#SVGID_00000004504346287636402360000009471206339492873398_)"
    },
    width: 17.3,
    height: 30.3
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_00000085229535185695850650000002724754090391436417_",
    gradientUnits: "userSpaceOnUse",
    x1: 190.7346,
    y1: 295.3436,
    x2: 185.12,
    y2: 322.5412,
    gradientTransform: "matrix(0.9201 0.4166 0.3886 -0.9986 -285.9757 266.7901)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#0677FF",
      stopOpacity: 0
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    style: {
      stopColor: "#0677FF"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "url(#SVGID_00000085229535185695850650000002724754090391436417_)"
    },
    points: "-1.6,21.1 16.7,21.1  15.7,51.4 -1.6,51.4  "
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMvLogoMin);
export default __webpack_public_path__ + "static/media/mv_logo_min.402f7a67a0829be23bd007aa91570f55.svg";
export { ForwardRef as ReactComponent };